import { render } from "./offerList.vue?vue&type=template&id=4848075f"
import script from "./offerList.vue?vue&type=script&lang=js"
export * from "./offerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__